import { apiInstance, gql } from "@/services/httpAdapter";

export async function updateUserProfilePicture(locationId, userId) {
	const query = gql`
		mutation updateUserProfilePicture($locationId: String!, $userId: String!) {
			updateUserProfilePicture(locationId: $locationId, userId: $userId) {
				_id
				presignedProfilePicture
				locationId
			}
		}
	`;

	const variables = {
		locationId,
		userId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateUserProfilePicture;
	} catch (err) {
		throw new Error(err);
	}
}
